import * as z from "zod";

export const getTemuAuthUrl = {
  name: "getTemuAuthUrl" as const,
  input: z.object({}),
  output: z.object({ url: z.string() }),
};
